import { RolodexEntryType } from './rolodex/rolodexEntries'

export type DocumentViewerUrlPaths =
  | '/documents/$siteID'
  | '/import-wizard/$siteID'

export enum DocumentViewerAssetType {
  BLOWER = 'blower',
  VALVE = 'valve',
  VESSEL = 'vessel',
  BREAKER = 'breaker',
  COMPRESSOR = 'compressor',
  COOLER = 'cooler',
  DETECTOR = 'detector',
  ELEMENT = 'element',
  FAN = 'fan',
  FILTER = 'filter',
  HEATER = 'heater',
  INSTRUMENT = 'instrument',
  MOTOR = 'motor',
  PUMP = 'pump',
  SOLENOID = 'solenoid',
  STRAINER = 'strainer',
  TANK = 'tank',
  TRANSFORMER = 'transformer',
  TRANSMITTER = 'transmitter',
  ALL = 'all',
  SET_UNKNOWN = 'set-unknown',
  OFF_PAGE_CONNECTOR = 'off_page_connector',
}

export type NormalizedBBox = {
  left: number
  top: number
  width: number
  height: number
}

export type BoundingBoxJsonItem = {
  id: number
  bounding_box: NormalizedBBox
  text?: string
  type?: DocumentViewerAssetType
  linkedUnitId?: string
  groupId?: string
  linkedDocumentIds?: string[]
  assetId?: string
}

export type DocumentOcrPage = {
  pageNumber: number
  confirmed: BoundingBoxJsonItem[]
  unconfirmed: BoundingBoxJsonItem[]
  groups?: { id: string; boxes: BoundingBoxJsonItem[] }[]
}

export type DocumentOcrJSON = {
  pages: DocumentOcrPage[]
}

export interface SystemDocumentJSON {
  id: string
  size: number
  type: string
  uploadDate: string
  title: string
  filename: string
  description: string
  vendor_name?: string
  document_type?: string
  document_title?: string
  drawing_number?: string
  system?: string
  revision_code?: string
  revision_date?: string
  total_pages?: number
}

export type DocumentOcrEntry = {
  entry: {
    id: string
    type: RolodexEntryType.DOCUMENT_OCR
    data: DocumentOcrJSON
    tags: {
      site: string
      'system-document': string
    }
  }
}

export type SystemDocumentEntry = {
  entry: {
    id: string
    type: RolodexEntryType.SYSTEM_DOCUMENT
    data: SystemDocumentJSON
    tags: {
      [key: string]: string
    }
    updated_at: string
    last_updated_by: string
  }
}
